module.exports = __webpack_public_path__ + "img/tivo.3691a117.svg";